<template>
  <v-dialog persistent
            v-model="show"
            :width="dialogWidth">
    <base-dialog :class="blackText?'dialog-text-black':''">
      <template v-slot:title>
        <img alt=""
           src="@/assets/dialog_icon_error.svg" v-if="iconMark === 'warm'"/>
        <div v-html="title"></div>
      </template>
      <template v-slot:content>
        <div v-html="contentItem"></div>
      </template>
      <template v-slot:btn v-if="!hideCloseBtn" >
          <v-btn color="secondary"
                 @click.native="close">{{btnConfirmText}}</v-btn>
      </template>
    </base-dialog>
      <div class="close-x" v-if="iconClose"
           @click="close">
        <v-icon style="font-size:40px">close</v-icon>
      </div>
  </v-dialog>
</template>
<script>
import BaseDialog from './BaseDialog'
export default {
  extends: BaseDialog,
  props: {
    title: {
      type: String,
      default: '注意'
    },
    dialogWidth: {
      type: Number,
      default: 380
    },
    blackText: {
      type: Boolean,
      default: false
    },
    iconClose: {
      type: Boolean,
      default: false
    },
    iconMark: {
      type: String,
      default: ''
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    close () {
      const { closeHandler, afterClose } = this
      closeHandler && closeHandler()
      afterClose()
    }
  }
}
</script>
<style scope>
.v-dialog {
  border-radius: 10px!important;
  position: relative;
}
.close-x{
  width: 45px;
  height: 45px;
  color: #000;
  position: absolute;
  padding-left: 7px;
  top: 10px;
  right: 10px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

</style>
